<template>
  <v-container
    class="bg bg--gray"
    fill-height
    fluid
  >
    <LoginBox>
      <h1 class="login__title">{{ $t(`${namespace}.title`) }}</h1>
      <p v-html="$t(`${namespace}.text`)" />
    </LoginBox>
  </v-container>
</template>

<script>
export default {
  name: 'UnavailableSystemPage',
  data () {
    return {
      namespace: 'Views.UnavailableSystemPage'
    }
  }
}
</script>
